
    <span 
      class="report-status-badge report-status-badge-{{statusColor}} report-status-badge-{{size}}">
      {{statusText}}
    </span>
  